<template>
  <div id="index">
    <Header></Header>
    <Search></Search>
    <Nav></Nav>
    <div class="content">
      <div class="w">
        <div class="contentup clearfloat">
          <ul class="clearfloat">
            <li :class="{ active: 0 == sort }" @click="screenChange(0)">
              <p>综合</p>
            </li>
            <li :class="{ active: 2 == sort }" @click="screenChange(2)">
              <p>销量</p>
            </li>
            <li :class="{ active: 3 == sort }" @click="screenChange(3)">
              <p>评分</p>
            </li>
            <li class="shopstorelast">
              <p>
                所在地
                <span
                  ><img
                    class="img-default"
                    src="../../assets/images/nav_xia.png"
                    alt
                /></span>
              </p>
              <div class="shopstorebut">
                <!-- <h5>同城：<strong>北京</strong></h5> -->
                <div class="shopstoreups clearfloat">
                  <template v-for="(item, index) in province_list">
                    <p
                      :class="{ active: province_id == item.id }"
                      v-text="item.name"
                      @click="provinceChange(item.id)"
                    ></p>
                  </template>
                </div>
                <!-- <div class="shopseach clearfloat">
									<input type="text" placeholder="输入地区">
									<button>确定</button>
								</div> -->
              </div>
            </li>
          </ul>
          <div class="filtrate-r d-flex align-items-center">
            <div class="filtrate-r-page d-flex align-items-center">
              <div
                class="page-img"
                :style="{ cursor: page <= 1 ? 'no-drop' : 'pointer' }"
                @click="pagePerv()"
              >
                <img
                  class="img-default"
                  src="../../assets/images/goods_left.png"
                  alt
                />
              </div>
              <div class="page-num d-flex">
                <span
                  v-text="page * limit > row_count ? row_count : page * limit"
                ></span>
                /
                <p v-text="row_count"></p>
              </div>
              <div
                class="page-img"
                :style="{ cursor: page >= page_count ? 'no-drop' : 'pointer' }"
                @click="pageNext()"
              >
                <img
                  class="img-default"
                  src="../../assets/images/goods_right.png"
                  alt
                />
              </div>
            </div>
          </div>
        </div>

        <div class="shopstorelist">
          <h4>店铺街</h4>
          <template v-if="mch_list && mch_list.length">
            <div class="ttshop_store">
              <div
                class="ttshop_storelist clearfloat"
                v-for="(item, index) in mch_list"
                :key="index"
              >
                <div class="ttshop_storeleft">
                  <div class="ttshop_storeleftimg">
                    <img class="img-default" :src="item.logo" alt="" />
                  </div>
                  <div class="ttshop_storeleftext">
                    <h5 v-text="item.name"></h5>
                    <div
                      class="
                        ttshop_storepf
                        clearfloat
                        d-flex
                        justify-content-center
                      "
                    >
                      <span>服务体验</span>
                      <div class="ttshop_evaluatenums">
                        <el-rate
                          v-model="item.rate"
                          disabled
                          score-template="{item.rate}"
                        >
                        </el-rate>
                      </div>
                    </div>
                    <div
                      class="
                        ttshop_storebut
                        clearfloat
                        d-flex
                        justify-content-center
                      "
                    >
                      <!-- <router-link to="#" v-if="false">联系客服</router-link> -->
                      <router-link
                        :to="{ path: '/shop', query: { mch_id: item.id } }"
                        >进入店铺</router-link
                      >
                      <p @click="shopFollowClick(index)">
                        <template v-if="item.is_follow == 0">收藏店铺</template>
                        <template v-else>取消收藏</template>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="ttshop_storeright">
                  <div
                    class="ttshop_storerightlist clearfloat"
                    v-if="item.list && item.list.length"
                  >
                    <ul class="clearfloat">
                      <li
                        v-for="(value, key) in item.list"
                        @click="toGoods(value.id)"
                      >
                        <div class="ttshop_storeimg">
                          <img
                            class="img-default"
                            :src="value.cover_pic"
                            alt=""
                          />
                        </div>
                        <div class="ttshop_storetext">
                          <h5 v-text="value.name"></h5>
                          <p v-text="'￥' + value.price"></p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div
                    class="
                      not-goods
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                    v-else
                  >
                    <img
                      class="img-default"
                      src="../../assets/images/not-goods.png"
                      alt=""
                    />
                    <span>店铺暂无商品</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ttshop_myorderpage clearfloat">
              <el-pagination
                class="ttshop_pages"
                background
                @current-change="pegeChange"
                :current-page.sync="page"
                :page-size="limit"
                :hide-on-single-page="true"
                layout="prev, pager, next, total, jumper"
                :total="row_count"
              ></el-pagination>
            </div>
          </template>
          <p class="not-data" v-else>暂无相关店铺</p>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Search from "@/components/search/search";
import Nav from "@/components/nav/nav";
import Foot from "@/components/foot/foot";
export default {
  components: {
    Search,
    Header,
    Nav,
    Foot,
  },
  data() {
    return {
      page_count: 0, //总页数
      row_count: 0, //总条数
      page: 1, //当前页数
      limit: 10, //每页条数
      sort: 0, // 2=销量 3=评分
      province_id: "", //省份id
      mch_list: [],
      province_list: [],
    };
  },
  created() {
    this.getMchList();
    this.getProvince();
  },
  methods: {
    // 获取店铺列表
    getMchList() {
      this.$loading();
      let params = {
        page: this.page,
        limit: this.limit,
        sort: this.sort,
        province_id: this.province_id,
      };
      this.$api
        .mchList(params)
        .then((res) => {
          if (res.code == 0) {
            this.$loading().close();
            for (let i in res.data) {
              res.data[i].rate = Number(res.data[i].rate);
            }
            this.mch_list = res.data;
            this.page_count = res.page_count;
            this.row_count = Number(res.row_count);
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
    // 获取地区
    getProvince() {
      this.$api
        .province()
        .then((res) => {
          if (res.code == 0) {
            this.province_list = res.data;
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
    // 筛选
    screenChange(sort) {
      if (this.sort == sort) {
        return false;
      }
      this.sort = sort;
      this.page = 1;
      this.getMchList();
    },
    // 位置筛选
    provinceChange(id) {
      if (this.province_id == id) {
        return false;
      }
      this.province_id = id;
      this.page = 1;
      this.getMchList();
    },
    // 进入商品详情
    toGoods(id) {
      let url = this.$router.resolve({
        path: "/pages/goods/goods",
        query: {
          id: id,
        },
      });
      window.open(url.href);
    },
    // 关注店铺
    shopFollowClick(index) {
      this.$loading();
      let params = {
        mch_id: this.mch_list[index].id,
      };
      if (this.mch_list[index].is_follow == 0) {
        this.$api
          .shopFollow(params)
          .then((res) => {
            this.$loading().close();
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "收藏成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              this.mch_list[index].is_follow = 1;
            }
          })
          .catch((err) => {
            this.common.message(this, err);
          });
      } else {
        this.$api
          .shopUnFollow(params)
          .then((res) => {
            this.$loading().close();
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: "取消成功",
                type: "success",
                offset: 200,
                duration: 1000,
              });
              this.mch_list[index].is_follow = 0;
            }
          })
          .catch((err) => {
            this.common.message(this, err);
          });
      }
    },
    // 导航分页上一页
    pagePerv() {
      if (this.page > 1) {
        this.page--;
        this.common.backTop();
        this.getMchList();
      }
    },
    // 导航分页下一页
    pageNext() {
      if (this.page < this.page_count) {
        this.page++;
        this.common.backTop();
        this.getMchList();
      }
    },
    // 输入分页
    pegeChange(e) {
      this.page = e;
      this.common.backTop();
      this.getMchList();
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  background-color: #f2f2f2;
  border-top: 2px solid #ff0e25;
  padding: 20px 0 42px 0;
  box-sizing: border-box;

  .contentup {
    width: 100%;
    height: 40px;
    background: #fff;
    margin-bottom: 10px;

    ul {
      float: left;

      li {
        float: left;
        width: 64px;
        text-align: center;
        margin-right: 20px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }

        &.active p {
          color: #ff0e25;
        }

        &.active p::before {
          width: 100%;
        }

        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;

        p {
          font-size: 12px;
          color: #666;
          font-weight: 400;
          line-height: 40px;
          position: relative;

          &::before {
            content: "";
            width: 0%;
            height: 2px;
            background: #ff0e25;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            -moz-transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
            -o-transform: translateX(-50%);
          }

          span {
            display: inline-block;
            width: 12px;
            height: 12px;
            vertical-align: -2px;

            img {
              display: block;
            }
          }
        }
      }

      .shopstorelast {
        width: 80px;
        border: 1px solid #fff;
        border-bottom: 0;
        box-sizing: border-box;
        position: relative;

        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background: #fff;
          position: absolute;
          bottom: -1px;
          left: 0;
          display: none;
        }

        &::before {
          display: none;
        }

        &:hover {
          border-color: #c8c8c8;
        }

        &:hover::after {
          display: block;
        }

        &:hover .shopstorebut {
          display: block;
        }

        p {
          span {
            width: 9px;
            height: 6px;
            vertical-align: 0px;
          }
        }

        .shopstorebut {
          min-width: 427px;
          position: absolute;
          top: 40px;
          left: -1px;
          // padding: 14px 21px 24px 21px;
          padding: 24px 21px 10px;
          box-sizing: border-box;
          background: #fff;
          border: 1px solid #c8c8c8;
          display: none;

          h5 {
            font-size: 12px;
            color: #666;
            font-weight: 400;
            line-height: 12px;
            margin-bottom: 20px;
            text-align: left;

            strong {
              color: #333;
              font-weight: 400;
            }
          }

          .shopstoreups {
            width: 100%;
            border-bottom: 2px dashed #d7d7d7;
            // margin-bottom: 14px;
            box-sizing: border-box;

            &:last-child {
              border-bottom: 0;
            }

            p {
              float: left;
              font-size: 12px;
              color: #666;
              cursor: pointer;
              font-weight: 400;
              line-height: 12px;
              margin-bottom: 14px;
              margin-right: 28px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover,
              &.active {
                color: #ff0e25;
              }
            }
          }

          .shopseach {
            width: 100%;

            input[type="text"] {
              float: left;
              width: 212px;
              height: 26px;
              padding: 0 8px;
              border: 1px solid #dfdfdf;
              outline: none;
              box-sizing: border-box;
              font-size: 12px;
              color: #333;
              margin-right: 8px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:focus {
                border-color: #ff0e25;
              }
            }

            button {
              float: left;
              width: 52px;
              height: 26px;
              text-align: center;
              line-height: 26px;
              color: #fff;
              font-size: 12px;
              border: 0;
              background: #ff0e25;
              outline: none;
              cursor: pointer;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover {
                box-shadow: 0 4px 8px rgba(255, 13, 47, 0.25);
              }
            }
          }
        }
      }
    }

    .filtrate-r {
      float: right;
      margin-top: 13px;

      .filtrate-r-page {
        margin-right: 16px;
        margin-left: 8px;

        .page-num {
          font-weight: bold;
          color: #666666;
          margin: 0 4px;

          span {
            font-weight: bold;
            color: #ff0e25;
          }
        }

        .page-img {
          height: 14px;
          width: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .shopstorelist {
    width: 100%;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;

    h4 {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
      font-weight: 500;
      padding-left: 8px;
      border-left: 3px solid #ff0e25;
      box-sizing: border-box;
    }
    .not-data {
      font-size: 14px;
      text-align: center;
      color: #666;
    }
    .ttshop_store {
      width: 100%;

      .ttshop_storelist {
        width: 100%;
        border: 1px solid #ebebeb;
        box-sizing: border-box;
        height: 260px;
        margin-bottom: 16px;

        .ttshop_storeleft {
          float: left;
          width: 220px;
          border-right: 1px solid #ebebeb;
          padding-top: 30px;
          box-sizing: border-box;
          height: 260px;
          position: relative;
          overflow: hidden;

          .ttshop_storeleftimg {
            width: 100px;
            height: 100px;
            margin: 0 auto 22px;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .ttshop_storeleftext {
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;

            h5 {
              font-size: 14px;
              color: #333;
              line-height: 14px;
              font-weight: 600;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 10px;
            }

            .ttshop_storepf {
              width: 100%;
              margin-bottom: 12px;

              span {
                float: left;
                font-size: 12px;
                color: #333;
                line-height: 18px;
                margin-right: 8px;
              }
            }

            .ttshop_storebut {
              width: 100%;
              padding: 0 14px;
              box-sizing: border-box;

              a,
              p {
                cursor: pointer;
                float: left;
                width: 75px;
                height: 28px;
                color: #ff0e25;
                font-size: 12px;
                text-align: center;
                line-height: 28px;
                border-radius: 2px;
                border: 1px solid #ff0e25;
                margin-right: 16px;

                &:last-child {
                  border-color: #ff9010;
                  color: #ff9010;
                  margin-right: 0;
                  &:hover {
                    background: #f8f2eb;
                    color: #faab51;
                  }
                }
                &:hover {
                  background: #f8eaeb;
                  color: #fa3246;
                }
              }
            }
          }
        }

        .ttshop_storeright {
          float: left;
          // width: 928px;
          width: 927px;
          height: 258px;
          padding: 30px 22px;
          box-sizing: border-box;

          .ttshop_storerightlist {
            width: 100%;

            ul {
              li {
                float: left;
                width: 121px;
                margin-right: 31px;
                cursor: pointer;

                &:last-child {
                  margin-right: 0;
                }

                &:hover .ttshop_storeimg img {
                  -webkit-transform: scale(1.1);
                  -moz-transform: scale(1.1);
                  -o-transform: scale(1.1);
                  -ms-transform: scale(1.1);
                  transform: scale(1.1);
                }

                &:hover .ttshop_storetext h5 {
                  color: #ff0e25;
                }

                .ttshop_storeimg {
                  width: 100%;
                  height: 121px;
                  margin-bottom: 16px;
                  overflow: hidden;

                  img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }
                }

                .ttshop_storetext {
                  width: 100%;

                  h5 {
                    font-size: 12px;
                    color: #666;
                    font-weight: 400;
                    line-height: 18px;
                    height: 36px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    margin-bottom: 15px;
                    transition: 0.5s;
                    -moz-transition: 0.5s;
                    -webkit-transition: 0.5s;
                    -o-transition: 0.5s;
                  }

                  p {
                    font-size: 16px;
                    color: #ff0e25;
                    font-weight: 500;
                    line-height: 16px;
                  }
                }
              }
            }
          }

          .not-goods {
            width: 100%;
            height: 100%;
            background: #f5f5f5;

            img {
              width: 100px;
              height: 100px;
              margin-right: 26px;
            }

            span {
              font-size: 14px;
              color: #9c9c9c;
            }
          }
        }
      }
    }

    .ttshop_myorderpage {
      width: 100%;
      margin-top: 20px;

      .ttshop_pages {
        float: right;
      }
    }
  }
}
</style>
